import { DATA_IMPORT_FEATURE_FLAGS } from '../features';
import { useAtlasFeatures } from './use-atlas-features';

export interface DataImportAccess {
  isAllowed: boolean;
  isLoading: boolean;
}

// Seam: today access is derived from Atlas *features*. To switch to Atlas
// *permissions* later, change only the body of this hook — the return shape
// ({ isAllowed, isLoading }) and every consumer stay the same.
export const useDataImportAccess = (): DataImportAccess => {
  const { data, isLoading } = useAtlasFeatures();
  const isAllowed = !!data?.some((feature) => DATA_IMPORT_FEATURE_FLAGS.includes(feature.name));

  return { isAllowed, isLoading };
};
